module.exports = __webpack_public_path__ + "static/media/68a344f978911bbeeda903f6_3487b4d6a931b25e51c333486600a08a_TC-Logo-Main 1.0ddc28b9.png";